import React, { FC, memo } from 'react'
import cn from 'classnames'

import { ITeam, IUser } from '../../../types/user'
import Toggle from '../../../components/Toggle'

interface IUserFormProps {
  user: IUser
  teams: ITeam[]
  setUser: (user: IUser) => void
}

const TeamsForm: FC<IUserFormProps> = ({ user, teams, setUser }) => {
  const userTeamsInCurrentBranch = (user.teams || [])
    .filter((team) => teams.some((t) => t.id === team.id))
    .map((t) => t.id)

  const teamOptions = [{ id: 'all', name: 'All teams' }, ...teams]

  return (
    <div className="user-form_field">
      <label className="section_label">Teams</label>
      {teamOptions.map((option) => (
        <Toggle<string | number | boolean>
          className={cn({ 'user-form_all': option.id === 'all' })}
          value={
            option.id === 'all'
              ? teams.every((el) => userTeamsInCurrentBranch.includes(el.id))
              : userTeamsInCurrentBranch.includes(option.id as number)
          }
          key={option.id}
          onChange={() => {
            const isAll = option.id === 'all'
            let updatedTeams = [...(user.teams || [])]

            if (isAll) {
              const currentTeamIds = teams.map((t) => t.id)
              const userTeamIdsInCurrentBranch = updatedTeams
                .filter((t) => currentTeamIds.includes(t.id))
                .map((t) => t.id)

              const allSelected = teams.every((t) =>
                userTeamIdsInCurrentBranch.includes(t.id),
              )

              if (allSelected) {
                updatedTeams = updatedTeams.filter(
                  (t) => !currentTeamIds.includes(t.id),
                )
              } else {
                const missingTeams = teams.filter(
                  (t) => !updatedTeams.some((ut) => ut.id === t.id),
                )
                updatedTeams = [...updatedTeams, ...missingTeams]
              }
            } else {
              const teamId = option.id as number
              const exists = updatedTeams.some((t) => t.id === teamId)
              if (exists) {
                updatedTeams = updatedTeams.filter((t) => t.id !== teamId)
              } else {
                const team = teams.find((t) => t.id === teamId)
                if (team) {
                  updatedTeams = [...updatedTeams, team]
                }
              }
            }
            setUser({ ...user, teams: updatedTeams })
          }}
          option={{
            value: true,
            label: option.name,
          }}
        />
      ))}
    </div>
  )
}

export default memo(TeamsForm)
